import { SnakeTabResponseDtoSection } from '@/lib/models';
import type { SnakeTabResponseDto } from '@/lib/models';

/** Snake tab keys in their stable enum form. */
export type SnakeTabKey = (typeof SnakeTabResponseDtoSection)[keyof typeof SnakeTabResponseDtoSection];

/** A resolved snake tab ready to render: its key + initial open state. */
export interface ResolvedSnakeTab {
  section: SnakeTabKey;
  /** Initial expanded state from the admin `defaultOpen` flag. */
  defaultOpen: boolean;
}

/**
 * Resolve the admin-driven snake info-tab order (ARC-84 §5).
 *
 * The API (`/snake/config/tabs`) already returns the tabs in admin order, so we
 * preserve array order (no `sortOrder` field on the wire). Unknown section keys
 * are dropped so a future server enum value can't crash the page. Returns `[]`
 * for missing/empty config.
 */
export function buildSnakeTabs(config: SnakeTabResponseDto[] | undefined): ResolvedSnakeTab[] {
  if (!config || config.length === 0) return [];

  const known = new Set<string>(Object.values(SnakeTabResponseDtoSection));

  return config
    .filter((row) => known.has(row.section))
    .map((row) => ({ section: row.section, defaultOpen: row.defaultOpen }));
}
